export default __webpack_public_path__ + "static/media/no_image.1287f47e.jpg";